import './index.css';

const LinkoviProširenoEs = () => {
    return (
        <>
            <div className="row">
                <h2>Ligiloj al utila enhavo kaj informoj</h2>
                <p>
                    Mi estas membro de la jenaj konstelaciaj asocioj:
                    <ul>
                        <li>
                            ISCA -{' '}
                            <a href="https://isca-network.org/" className="learn" style={{ color: '#00509f' }}>
                                {' '}
                                International system constellations association
                            </a>
                        </li>
                        <li>
                            Constelators international -{' '}
                            <a
                                href="https://constellators-international.com/"
                                className="learn"
                                style={{ color: '#00509f' }}
                            >
                                constellators-international
                            </a>
                        </li>
                        <li>
                            Udruga „Konstelacija“ -{' '}
                            <a href="https://udrugakonstelacija.com/" className="learn" style={{ color: '#00509f' }}>
                                Udruga "KONSTELACIJA" - Constellations According to Hellinger International
                            </a>
                        </li>
                    </ul>
                </p>
                <p>
                    International Pliaj interesaj kaj utilaj ligiloj:
                    <ul>
                        <li>la paĝo de miaj instruistoj Alemka kaj Max Dauskardt:</li>
                        <li>
                            <a
                                href="https://konstelacijakroacija.wordpress.com/"
                                className="learn"
                                style={{ color: '#00509f' }}
                            >
                                Notoj pri la animo | Impresoj sur la Animo - Konstelacioj laŭ Hellinger
                            </a>
                            <ul>
                                <li>
                                    <a
                                        href="https://konstelacijakroacija.wordpress.com/konstelacije/"
                                        className="learn"
                                        style={{ color: '#00509f' }}
                                    >
                                        Sistemaj Konstelacioj | Notoj pri la animo
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://konstelacijakroacija.wordpress.com/resursi-3/clanci/"
                                        className="learn"
                                        style={{ color: '#00509f' }}
                                    >
                                        Artikoloj &amp; Blogoj | Notoj pri la animo
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://konstelacijakroacija.wordpress.com/blog/"
                                        className="learn"
                                        style={{ color: '#00509f' }}
                                    >
                                        Blogo | Notoj pri la animo
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://konstelacijakroacija.wordpress.com/resursi-3/"
                                        className="learn"
                                        style={{ color: '#00509f' }}
                                    >
                                        Rimedoj | Notoj pri la animo
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </p>
                <p>
                    Alia Mem/ AnotherSelf - ĉe Netflix vi povas spekti interesan serion, kiu bone montras la principojn
                    de sistema kaj familia amo.
                </p>
                <p>
                    En la serio, tri amikoj solvas siajn vivproblemojn kun la helpo de konstelacioj rigardante en la
                    pasintecon de siaj familioj.
                    <ul>
                        <li>
                            Jutuba Anonco: Alia Mem | Oficiala Antaŭfilmo | Netflix Videoj kaj ligiloj
                            <a
                                href="https://www.youtube.com/watch?v=Pzl33KQP8b4"
                                className="learn"
                                style={{ color: '#00509f' }}
                            >
                                {' '}
                                Another Self | Offical Trailer | Netflix
                            </a>
                        </li>
                    </ul>
                </p>
            </div>
            <div className="row">
                <h2>Videoj kaj ligiloj</h2>
            </div>
            <div className="row">
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Prilog u Tv-emisiji: Dobro jutro Hrvatska, povodom seminara Stefana Hausera</h3>
                    </div>
                    <iframe
                        width="100%"
                        height="300px"
                        className="yt-video"
                        src="https://www.youtube.com/embed/ycibfRCr_ic?wmode=opaque&amp;rel=0"
                        title="Prilog u Tv-emisiji: Dobro jutro Hrvatska, povodom seminara Stefana Hausera"
                        allowFullScreen={true}
                    ></iframe>
                </div>
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Na rubu znanosti: Sistemske konstelacije i odnosi, razgovor sa Alemkom Dauskardt</h3>
                    </div>
                    <iframe
                        width="100%"
                        height="300px"
                        className="yt-video"
                        src="https://www.youtube.com/embed/Ff4GjTEOpjE"
                        title="Na rubu znanosti: Sistemske konstelacije i odnosi razgovor sa Alemkom Dauskardt"
                        allowFullScreen={true}
                    ></iframe>
                </div>
                <div className="yt-title"></div>
            </div>
            <div className="row">
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Na rubu znanosti: Sistemske konstelacije,razgovor sa Stefanom Hauserom</h3>
                    </div>
                    <iframe
                        width="100%"
                        height="300px"
                        className="yt-video"
                        src="https://www.youtube.com/embed/7aORJaZceo8"
                        title="Na rubu znanosti: Sistemske konstelacije,razgovor sa Stefanom Hauserom"
                        allowFullScreen={true}
                    ></iframe>
                </div>
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Na rubu znanosti: Trauma i sistemske konstelacije, razgovor sa Anngwyn St Just</h3>
                    </div>
                    <iframe
                        width="100%"
                        height="300px"
                        className="yt-video"
                        src="https://www.youtube.com/embed/3WdwF72-aCA"
                        title="Na rubu znanosti: Trauma i sistemske konstelacije, razgovor sa Anngwyn St Just"
                        allowFullScreen={true}
                    ></iframe>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Vedran i Ankica: Pobačaj - duhovne posljedice i iscjeljivanje.</h3>
                    </div>
                    <iframe
                        src="https://www.facebook.com/plugins/video.php?height=300&href=https%3A%2F%2Fwww.facebook.com%2Falkemijazivota%2Fvideos%2F2736338436506540%2F&show_text=false&width=480&t=0"
                        className="yt-video"
                        width="100%"
                        height="300px"
                        allowFullScreen={true}
                    ></iframe>
                </div>
                <div className="col-md-12 col-td-6 col-6">
                    <div className="yt-title mg-top-20">
                        <h3>Na rubu znanosti: Sistemske konstelacije i partnerski odnosi</h3>
                    </div>
                    <iframe
                        width="100%"
                        height="300px"
                        className="yt-video"
                        src="https://www.youtube.com/embed/Ff4GjTEOpjE"
                        title="Na rubu znanosti - SISTEMSKE KONSTELACIJE I PARTNERSKI ODNOSI"
                        allowFullScreen={true}
                    ></iframe>
                </div>
            </div>
        </>
    );
};

export default LinkoviProširenoEs;
